<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <app-upsert
        :config="config"
        :item="item"
        @saved="saved">


        <template slot='headerActions'>
          
          <v-btn
            color="secondary"
            @click="$router.push('/templates')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

        </template>

        <template slot='actions'>
          <!--v-btn
            color="secondary"
            @click="$router.push('/protocol_roles/' + protocol.id)">
            Roles
          </v-btn-->
        </template>
       
      </app-upsert>

       <v-card >
        <v-card-text class="text-h5 font-weight-bold">
          <core-file-upload ref="fileUpload" @input="uploadFiles" :multiple="true" label="Trascina qua i file che vuoi caricare"/>

            <v-list-item
              v-for="file in files"
              :key="file.id"
            >

                <v-list-item-content>
                  <v-list-item-title v-text="file.name"></v-list-item-title>
                  <v-list-item-subtitle><a :href="$store.getters.s3BaseUrl + (file.path ? file.path : '') + file.uuid + file.extension">download</a></v-list-item-subtitle>
                </v-list-item-content>


                <v-list-item-action>
                  <v-btn icon>
                    <v-icon @click="deleteFile(file)" color="grey lighten-1">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>

            </v-list-item>
        </v-card-text>
      </v-card>
      
    </v-flex>

  </v-container>
</template>

<script>
import { getDetail, getList, post, remove } from '@/api/base_entity'
import config from './config_index.js'
import { mapActions } from 'vuex'

export default {
  inheritAttrs: false,
  data () {
    return {
      config,
      item: {},
      itemId: null,
      files: []
    }
  },
  async created () {
    if (this.$route.params.id) {
      this.itemId = this.$route.params.id
      this.getData()
    }
    // this.hiddenFields = { protocol_id: this.protocol.id }

  },
  mounted() {
     this.getConfig()
  },
  computed: {
    isNew() {
      return this.item.id ? false : true
    },
  },
  watch: {
  },
  methods: {
    ...mapActions('app', ['getConfig']),
    async getData() {
      this.item = await getDetail('template', { id: this.itemId })
      this.loadFiles()
      delete this.item.text
    },
    async loadFiles() {
      const ret = await getList('file', { entity:'template', entity_id: this.itemId }, {rowsPerPage: -1})
      this.files = ret['data']
    },
    uploadFiles(files) {

      var promises = [];

      files.map( file => {
        
        const fileObj = {
          'lastModified': file.lastModified,
          'name': file.name,
          'size': file.size,
          'type': file.type,
          'base64': file.base64,
          'entity': 'template',
          'entity_id': this.itemId,
          'path': 'template/' + this.itemId + '/'
        } 

        var upl = post("file", fileObj)
        upl.then( () => {
          this.loadFiles()
        })
        promises.push(upl)
      })
       
      Promise.all(promises).then( (all) => {
        const message = all.length == 1 ? "File caricato correttamente" : "File caricati correttamente"
        this.$root.$emit('openSnackbar', {
          message,
          color: 'success'
        })
        
        this.loadFiles()
        
      }).catch( () => {
        this.$root.$emit('openSnackbar', {
          message: 'Si è verificato un errore durante il caricamento di uno o più file',
          color: 'error'
        })
      }).finally( () => {
        this.$refs.fileUpload.setBusy(false)
      })

    },
    saved (item) {
      this.itemId = item.data.id
      if(this.isNew) {
        this.$router.push("/template/" + item.data.id)
      }
      this.getData()
    },
    async deleteFile(item) {

      const ret = await this.$root.$confirm.open("Cancellazione", "Sicuro di voler cancellare questo file : " + item.name + "?", { color: 'red' })
      if (!ret) {
        return
      }

      remove('file', item).then( () => {
        this.$root.$emit('openSnackbar', {
          message: 'Il file è stato rimosso correttamente',
          color: 'success'
        })
        this.loadFiles()
      })
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
